export const MyGarageSteps = [
  {
    label: "General Info",
    value: "generalInfo",
  },
  {
    label: "Questionare",
    value: "questionare",
  },
  {
    label: "Specifications",
    value: "specifications",
  },
  {
    label: "Gallery",
    value: "gallery",
  },
];

export const CarColorOptions = [
  {
    label: "Select Your Car Color",
    value: "",
  },
  { label: "Red", value: "Red" },
  { label: "Orange", value: "Orange" },
  { label: "Yellow", value: "Yellow" },
  { label: "Green", value: "Green" },
  { label: "Blue", value: "Blue" },
  { label: "Pink", value: "Pink" },
  { label: "Purple", value: "Purple" },
  { label: "Indigo", value: "Indigo" },
  { label: "Indigo", value: "Indigo" },
  { label: "Violet", value: "Violet" },
  { label: "Brown", value: "Brown" },
  { label: "Gray", value: "Gray" },
  { label: "Black", value: "Black" },
  { label: "White", value: "white" },
];

export const CarKeyOptions = [
  {
    label: "Select Your Car Key",
    value: "",
  },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
];

export const DamageOptions = {
  exterior: ["Minor Damage", "Fading Paints", "Rust", "Hail Damage", "Dents"],
  interior: [
    "Rips on Seats",
    "Visible Stains",
    "Strong Smell",
    "Damaged Systems",
  ],
  tires: [
    "2 Sets of Tires",
    "Window Tint",
    "Aftermarket Wheels",
    "Aftermarket Rims",
    "Roof Racks",
  ],
  accessories: ["Remote Starter", "Aftermarket Stereo", "Aftermarket Spoiler"],
};

export const TransmissionOptions = {
  AUTOMATIC: "Automatic",
  MANUAL: "Manual",
};

export const CarSellQuestionnaire = [
  { name: "Smoke_In_Vehicle", label: "Do you smoke in this vehicle?" },
  {
    name: "Original_Factory_Rims",
    label: "Do you have original factory rims?",
  },
  {
    name: "Tires_Repld_12_Months",
    label: "Have you replaced your tires in the last 12 months?",
  },
  { name: "Windshield_Crack", label: "Any crack on the windshield?", required: true },
  { name: "Extended_Warranty", label: "Do you have any extended warranty?" },
  { name: "Vehicle_Drivable", label: "Is your vehicle drivable?", required: true },
];

export const pageTabs = {
  view: "view",
  sellNewCar: "sellNewCar",
};

export const mileageUnits = {
  km: "km",
  mi: "mi"
};
